import React from 'react'

export default function HeatMap({ heading, Data }) {
    return (
        <>
            <div className='Areachart-box'>
                <div className='topHeader'>
                    <div>
                        <h5>{heading}</h5>
                    </div>


                </div>
                <div style={{ display: 'flex', justifyContent: 'end', gap: '5px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                        <h5 style={{ fontSize: '8px', fontWeight: '400', color: "rgba(104, 108, 112, 1)" }}>Drop Of by 0%</h5>
                        <div style={{ display: 'flex' }}>
                            <div style={{ width: '10px', height: '10px', background: "rgba(252, 205, 134, 1)" }}></div>
                            <div style={{ width: '10px', height: '10px', background: "rgba(250, 179, 100, 1)" }}></div>
                            <div style={{ width: '10px', height: '10px', background: "rgba(246, 133, 66, 1)" }}></div>
                            <div style={{ width: '10px', height: '10px', background: "rgba(246, 110, 68, 1)" }}></div>
                            <div style={{ width: '10px', height: '10px', background: "rgba(244, 99, 78, 1)" }}></div>
                        </div>
                        <h5 style={{ fontSize: '8px', fontWeight: '400', color: "rgba(104, 108, 112, 1)" }}>25%</h5>
                    </div>

                </div>
                <div>
                    {
                        Data?.length > 0 ?

                           <div className='customHeatmaptable'>
                            <table className='table'>
                                <thead>
                                    <tr>
                                        <th style={{border:"none"}}></th>
                                        <th style={{borderTopLeftRadius:"8px"}}>KYC</th>
                                        <th>Credit</th>
                                        <th>Bank Parsing</th>
                                        <th style={{borderTopRightRadius:"8px"}}>eSign</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td style={{borderTopLeftRadius:"8px"}}>Aggregator A</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>Aggregator B</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>Aggregator C</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>Aggregator D</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td style={{borderBottomLeftRadius:"8px"}}>Aggregator E</td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td style={{borderBottomRightRadius:"8px"}}></td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                          : ""} 
                </div>
            </div>
        </>
    )
}
